import { Trans, useTranslation } from 'next-i18next'
import styled from 'styled-components'
import { FONT_WEIGHT } from '@fe/common/constants/main'

const BankLink = styled.a`
  font-weight: ${FONT_WEIGHT.SEMIBOLD};
  text-decoration: underline;

  :hover {
    opacity: 0.7;
  }
`

interface InterbankInstructionProps {
  description?: string | null
  uid?: string | null
  account_number?: string | null
  bank_name?: string | null
  brand?: string | null
  local_number?: string | null
  payment_link?: string | null
  registration_url?: string | null
}

// The tags both texts may use. Only the link differs: the fallback text
// gets the bank's registration page as its href.
const TAGS = {
  p: <p />,
  ol: <ol />,
  li: <li />,
  b: <b />,
}

// How to pay an Interbank deposit. The bank's own text when it sent one,
// otherwise our interbank-instruction text with the bank's values.
export const InterbankInstruction: React.FC<InterbankInstructionProps> = ({
  description,
  uid,
  account_number,
  bank_name,
  brand,
  local_number,
  payment_link,
  registration_url,
}) => {
  const { t } = useTranslation('transactions')

  if (description) {
    return (
      <Trans
        defaults={description}
        t={t}
        values={{
          uid,
          account_number,
          bank_name,
          brand,
          local_number,
          payment_link,
          registration_url,
        }}
        components={{
          ...TAGS,
          a: <BankLink rel="noopener noreferrer" target="_blank" />,
        }}
      />
    )
  }

  return (
    <Trans
      i18nKey="interbank-instruction"
      t={t}
      values={{
        bank_name,
        local_number,
        payment_details: account_number,
        registration_url,
      }}
      components={{
        ...TAGS,
        a: (
          <BankLink
            href={registration_url}
            rel="noopener noreferrer"
            target="_blank"
          />
        ),
      }}
    />
  )
}
